import React from "react";
import { ApplicableToContainer } from "../../../containers";

const ApplicableTo = (props) => {
  return <ApplicableToContainer {...props} />;
};

export default ApplicableTo;
